import { render, staticRenderFns } from "./IconYouTube.vue?vue&type=template&id=abb2afea&scoped=true&"
import script from "./IconYouTube.vue?vue&type=script&lang=js&"
export * from "./IconYouTube.vue?vue&type=script&lang=js&"
import style0 from "./IconYouTube.vue?vue&type=style&index=0&id=abb2afea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb2afea",
  null
  
)

export default component.exports